import axios from 'axios';
import { useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import BaseURL from '../Utilities/BaseUrl';
import {cartContext}from'../Contexts/CartContext';
import { Helmet } from 'react-helmet';
export default function Resetcode() {
  let {setcheck}=useContext(cartContext);
    const [errormesg, seterrormesg] = useState("");
    const [sucessmesg, setsucessmesg] = useState("");
    const [loading, setloading] = useState(true);
    const [disab, setdisab] = useState(true);
    let navigate = useNavigate();
    let Formik = useFormik({
        initialValues: {
            resetCode: "",
          
        },
    
        onSubmit: (values) => {
          setloading(false);
          setdisab(false);
          
          axios.post(`${BaseURL}auth/verifyResetCode`,values)
            .then((data) => {
      
              if (data.status == 200) {
                
                setsucessmesg(data.data.message);

               setTimeout(() => {
                    
                navigate('/Resetpassword');
                  }, 1000);
              
                }
            })
            .catch((error) => {
              if (error.response.status == 400)
              {
               
                 seterrormesg(error.response.data.message);
               
                 setloading(true)
                 setdisab(true)
              }
                
            });
          }
        
        })
        useEffect(() => {
          setcheck(true);
        
          
        }, [])
  return <><Helmet>
  <title>ResetCode</title>
  
</Helmet>
  <div className="container pt-5 pb-5">
        <div className="row">
          <div className="col-12">

      <div className="resetcodeForm">
      {errormesg !=''? 
              <div className="position-fixed top-10 end-80 p-3 mt-5 ">
              <div
                id="liveToast"
                className="toast  show  "
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
              >
                <div className="toast-header position-relative  border-0 bg-danger ">
                  <button
                    type="button"
                    className="btn-close position-absolute end-0 me-2 mt-2 shadow-none"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="toast-body text-center bg-danger pb-3 fw-bold text-white">
                 Error !..  { errormesg}
                </div>
              </div>
            </div>
             : 
              ""
            }

{sucessmesg ? 
              <div className="position-fixed top-10 end-80 p-3 mt-5 bg-sucess">
                <div
                  id="liveToast"
                  className="toast  show  "
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  <div className="toast-header position-relative  border-0 bg-success">
                    <button
                      type="button"
                      className="btn-close position-absolute end-0 me-2 mt-2 shadow-none"
                      data-bs-dismiss="toast"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="toast-body text-center bg-success pb-3 fw-bold text-white">
                    {sucessmesg } 
                  </div>
                </div>
              </div>
             : 
              ""
            }
           
          
           <form onSubmit={Formik.handleSubmit}>
          <label htmlFor="resetCode">resetCode :</label>
          <input
            onChange={Formik.handleChange}
            onBlur={Formik.handleBlur}
            type="text"
            name="resetCode"
            id="resetCode"
            placeholder="Enter Your resetCode"
            className="form-control mt-3 w-75 mb-4 shadow-none"
            value={Formik.values.email}
          />
          {Formik.errors.resetCode && Formik.touched.resetCode ? (
            <div className="alert alert-danger w-75">{Formik.errors.resetCode}</div>
          ) : (
            ""
          )}

<button
            type="submit"
            className="btn bg-main px-5 py-2 mt-5 text-white"
            disabled={!(Formik.isValid && Formik.dirty && disab)}
          >
            {loading ? (
              <span>Continue</span>
            ) : (
              <span
                className="spinner-border text-white "
                role="status"
                width={10}
              ></span>
            )}
          </button>
          </form>

      </div>
      </div></div></div>
  
  </>
}
